"use client";

import { useState, useEffect, useCallback } from "react";
import { Button } from "@/components/ui/button";
import { useConnection } from "@/hooks/use-connection";
import { Loader2, Mic } from "lucide-react";
import { usePlaygroundState } from "@/hooks/use-playground-state";
// import { AuthDialog } from "./auth";

export function ConnectButton(props: any) {
  const { connect, disconnect, shouldConnect } = useConnection();
  const [connecting, setConnecting] = useState<boolean>(false);
  const { pgState, dispatch } = usePlaygroundState();
  const [showAuthDialog, setShowAuthDialog] = useState(false);
  const [initiateConnectionFlag, setInitiateConnectionFlag] = useState(false);

  // Load API key from environment variable
  const apiKey = process.env.NEXT_PUBLIC_OPENAI_API_SECRET;

  // Handle the connection toggle
  const handleConnectionToggle = async () => {
    if (shouldConnect) {
      await disconnect();
    } else {
      // if (!pgState.openaiAPIKey && !apiKey) {
      //   setShowAuthDialog(true); // Show auth dialog if API key is missing
      // } else {
      //   if (apiKey) {
      //     dispatch({ type: "SET_API_KEY", payload: apiKey }); // Set API key from env if available
      //   }
        await initiateConnection(props);
      // }
    }
  };

  // Function to initiate the connection
  const initiateConnection = useCallback(
    async (props: any) => {
      setConnecting(true);
      try {
        await connect(props);
      } catch (error) {
        console.error("Connection failed:", error);
      } finally {
        setConnecting(false);
      }
    },
    [connect],
  );

  // Called when API key is successfully set in AuthDialog
  const handleAuthComplete = (submittedApiKey: string) => {
    dispatch({ type: "SET_API_KEY", payload: submittedApiKey }); // Store the API key
    setShowAuthDialog(false); // Close the Auth dialog
    setInitiateConnectionFlag(true); // Trigger the connection process after key is set
  };

  // Automatically initiate connection if API key is available
  useEffect(() => {
    if (initiateConnectionFlag && pgState.openaiAPIKey) {
      initiateConnection(props);
      setInitiateConnectionFlag(false);
    }
  }, [initiateConnectionFlag, initiateConnection, pgState.openaiAPIKey]);

  return (
    <>
      <Button
        onClick={handleConnectionToggle}
        disabled={connecting || shouldConnect}
        className="text-sm font-semibold bg-oai-green"
        style={{
          display:
            props.instructions === "" ||
            props.instructions === null ||
            props.isSessionDone
              ? "none"
              : "inline-flex",
        }}
      >
        {connecting || shouldConnect ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Starting
          </>
        ) : (
          <>
            <Mic className="mr-2 h-4 w-4" />
            Start Session
          </>
        )}
      </Button>
      {/* <AuthDialog
        open={showAuthDialog}
        onOpenChange={setShowAuthDialog}
        onAuthComplete={handleAuthComplete} // Pass the callback when API key is set
      /> */}
    </>
  );
}
